import request from "@/utils/request";
// 测试接口
export function GetAccountBindList(params) {
  return request({
    url: "/h5/Setting/getAccountBindList",
    method: "post",
    params,
  });
}

// 解绑店铺
export function unbindShop(params) {
  return request({
    url: "/h5/Setting/unbindShop",
    method: "post",
    params,
  });
}

